<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}</div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div v-bind:class="[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]"
                 v-on:touchstart="touchstartup"v-on:mouseenter="scrollup" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
                <div class="top-arrow-text"
                     v-bind:style="[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                    {{ translations['Scroll up for further fabrics'] }}
                </div>
            </div>
            <div :id="box.component" class="fabric-select-btns">

                <div v-for="item in items"
                     v-bind:class="[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]">
                    <img v-bind:src="this.baseurl + 'media/' + item.thumb" v-bind:alt="item.name"
                         v-bind:title="item.name" v-bind:id="item.ref_number" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code"/>
                    <div class="name" v-bind:id="item.ref_number" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code">{{ item.name }}
                    </div>
                    <button v-bind:class="[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]"
                            v-bind:data-refnr="item.ref_number"
                            v-bind:data-title="item.name" v-bind:data-infotext='item.infotext'
                            v-bind:data-price='item.price'
                            type="button" @click="zoomFabric">Details
                    </button>
                </div>
            </div>
        </div>
        <div v-bind:class="[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]"
             v-on:touchstart="touchstartdown" v-on:mouseenter="scrolldown" v-on:mouseleave="mouseleave"
             v-on:touchend="touchend">
            <div class="bottom-arrow-text"
                 v-bind:style="[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                {{ translations['Scroll down for further fabrics'] }}
            </div>
        </div>

        <div class="designer-select-dropdown">

            <div class="designer-select-dropdown-col">

                <h3>{{ translations['Cuff width'] }}</h3>
                <p>{{ translations['Do you wear a watch under your cuff? We will make your cuff width bigger.'] }}</p>
                <div id="cuffwidth" class="designer-select">
                    <select title="{{ translations['Cuff width'] }}" id="cuffwidth" name="Manschettenweite" v-model="selected"
                            @change="updatePersonalCuff">
                        <option value="none">{{ translations['none_e'] }}</option>
                        <option value="watchleft">{{ translations['Watch left'] }}</option>
                        <option value="watchright">{{ translations['Watch right'] }}</option>
                    </select>

                </div>
            </div>
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals"></zoom>
</template>
<script>
import Zoom from '../partials/Zoom.vue'

export default {
  name: 'Cuff',
  data: function () {
    return {
      selected: (typeof this.personal['cuffwidth'] !== 'undefined' ? this.personal['cuffwidth'] : ''),
      globals: window.shirtdesigner,
      scrolling: false,
      touchstart: false,
      translations: window.shirtdesigner.translations,
      scrollPosition: 0,
      selectedScrollHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0),
      selectedClientHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0),
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      }
    }
  },
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive', 'zoom', 'show' ],
  components: {
    Zoom
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      this.isactive = event.currentTarget.id
    },
    updatePersonalCuff: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected])
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    scrolldown: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop + scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    scrollup: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop - scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    mouseleave: function () {
      if (this.scrolling) {
        window.clearInterval(this.scrolling)
        this.scrolling = false
      }
    },
    touchstartup: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop - scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchstartdown: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop + scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchend: function () {
      this.mouseleave()
    },
    checkMeasures: function () {
      this.selectedScrollHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0)
      this.selectedClientHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0)
    },
    itemsScroll: function () {
      var ele = document.getElementById(this.box.component)
      this.scrollPosition = ele.scrollTop
      this.checkMeasures()
    }
  },
  watch: {
    items: function () {
      this.checkMeasures()
    },
    filtertext: function () {
      this.checkMeasures()
    }
  },
  ready: function () {
    this.checkMeasures()
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Cuff.vue?4523a8ea